import React from 'react';

// Couple clé/valeur d'une fiche, partagé par la fiche appareil et la fiche
// utilisateur : les deux affichent des dizaines de champs et doivent traiter
// l'absence de valeur de la même façon — un tiret grisé, jamais une case vide
// qui laisse croire à un défaut de chargement.
//
// À placer dans un SpecFields, qui porte la grille dt/dd.
export function Champ({ label, children, className = '', full = false }) {
    return (
        <div className={full ? 'full' : undefined}>
            <dt>{label}</dt>
            <dd className={children === null || children === undefined ? 'empty' : className}>
                {children ?? '—'}
            </dd>
        </div>
    );
}
